import React from 'react';
import createSvgIcon from '../utils/createSvg';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M145 5C67.7 5 5 67.7 5 145s62.7 140 140 140 140-62.7 140-140S222.3 5 145 5zm64.5 192.1l-12.3 12.3-52.1-52.1-52.2 52.2-12.3-12.3 52.1-52.1-52.2-52.2 12.4-12.4 52.1 52.1 52.1-52.1 12.4 12.4-52.1 52.1 52.1 52.1z"
})), 'CloseFilledLightIcon');